<template>
    <div class="product-card" v-if="product.status">
        <a class="product-card-item"
           :href="product.url"
           @mouseleave="mouseLeave"
           @mouseover="mouseOver"
           :data-id="product.id">
            <div class="product-card-images" v-touch-swipe.right.left="swipe">
                <div v-if="product.images[0]"
                     class="product-card-img-wrapper">
                    <img :src="product.images[0]"
                         class="product-card-img"
                         :alt="product.name + ' ' + product.article"
                         width="240"
                         height="346"
                    />
                </div>
                <div v-else class="product-card-img-wrapper">
                    <img class="product-card-img"
                         src=""
                         :alt="product.name + ' ' + product.article"
                         width="240"
                         height="346"
                    />
                </div>
            </div>

            <template v-if="!hasStickyHeader">
                <div class="product-card-badge-container">
                    <div v-if="product.new" class="product-card-badge product-card-badge--new"><span>New</span></div>
                    <div v-if="product.discount" class="product-card-badge product-card-badge--sale"><span>-{{ product.discount }}%</span></div>
                </div>

                <div class="product-card-right-badges">
                    <q-btn flat class="icon-wrapper" @click.prevent="switchComparison()">
                        <span class="icon remove"></span>
                        <q-tooltip anchor="top middle" self="bottom middle">
                            <p>Удалить из сравнения</p>
                        </q-tooltip>
                    </q-btn>
                </div>
            </template>

            <div>
                <div class="product-card-purchase">
                    <div class="product-card-price" :class="{'product-card-price--sale' : hasDiscount}">
                        <span class="price-total">{{ totalPrice }}<span class="rub"> руб</span></span>
                        <span v-if="hasDiscount" class="price-old">{{ originalPrice }}<span class="rub"> руб</span></span>
                    </div>
                </div>

                <div class="product-card-title">
                    <span class="product-card-title-category">{{ product.name }}</span>
                </div>
            </div>
        </a>
    </div>
</template>

<script>
export default {
    props: {
        hasStickyHeader: {
            type: Boolean,
            default: false
        },
        product: {
            type: Object,
            required: true,
        },
    },
    data () {
        return {
            toggleImage: false,
        }
    },
    methods: {
        mouseOver () {
            if (this.$q.platform.is.desktop && this.product.images.length > 1) {
                this.toggleImage = true;
            }
        },
        mouseLeave () {
            if (this.$q.platform.is.desktop && this.product.images.length > 1) {
                this.toggleImage = false;
            }
        },
        swipe() {
            if (this.product.images.length > 1) {
                this.toggleImage = !this.toggleImage;
            }
        },
        switchComparison() {
            this.$root.switchComparison(this.product.id)
        }
    },
    computed: {
        promoCodeAppliedToProduct() {
            return !!(this.product.promo_code && this.product.promo_code.applied);
        },
        totalPrice() {
            return this.$root.priceFormat(this.promoCodeAppliedToProduct ? this.product.promo_code.final_price :  this.product.selling_price);
        },
        originalPrice() {
            return this.$root.priceFormat(this.product.price);
        },
        hasDiscount() {
            return !!(this.product.discount || this.promoCodeAppliedToProduct);
        },
        inComparison() {
            return this.$root.inComparison(this.product.id)
        }
    }
}
</script>

